import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function DevHelper() {
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  // Generate a test token (in production, this would come from your backend)
  const generateTestToken = () => {
    // This is just for testing - real tokens come from backend
    const testToken = 'test-token-' + Math.random().toString(36).substring(7);
    setToken(testToken);
  };

  const navigateToPortal = () => {
    if (token) {
      navigate(`/t/${token}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Customer Portal - Development Helper</h1>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Test Token Access</h2>
          
          <p className="text-gray-600 mb-4">
            In production, customers will receive links like:
            <br />
            <code className="bg-gray-100 px-2 py-1 rounded">
              https://connect.lynxpay.us/t/[secure-token]
            </code>
          </p>

          <div className="space-y-4">
            <div>
              <button
                onClick={generateTestToken}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Generate Test Token
              </button>
            </div>

            {token && (
              <div className="bg-gray-100 p-4 rounded">
                <p className="text-sm text-gray-600 mb-2">Test Token:</p>
                <code className="text-sm break-all">{token}</code>
                
                <div className="mt-4">
                  <button
                    onClick={navigateToPortal}
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                  >
                    Go to Portal with Token
                  </button>
                </div>
                
                <p className="text-sm text-gray-500 mt-2">
                  Direct URL: http://localhost:3001/t/{token}
                </p>
              </div>
            )}
          </div>

          <div className="mt-8 pt-6 border-t">
            <h3 className="font-semibold mb-2">How it works:</h3>
            <ol className="list-decimal list-inside text-sm text-gray-600 space-y-1">
              <li>Main app generates secure token via backend API</li>
              <li>Token contains encrypted invoice/customer data</li>
              <li>Customer receives link via email/SMS</li>
              <li>Portal validates token and shows relevant invoices</li>
              <li>No login required - token is the authentication</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevHelper;
